module.exports = __webpack_public_path__ + "static/media/FintwistCardArt_Lee_M-01.e736a4ec.svg";